import { GraduationCap } from 'lucide-react'

import { EntityCard } from '#app/routes/mocra+/_form+/components/entity-card.tsx'

import { TRAINING_PROGRAM_COPY } from '#app/routes/mocra+/_form+/components/training-programs/constants.ts'
import {
	formatTrainingProgramSummary,
	trainingProgramCardTitle,
	type TrainingProgramDraft,
} from '#app/routes/mocra+/_form+/components/training-programs/types.ts'

type Props = {
	readonly program: TrainingProgramDraft
	readonly onEdit: () => void
	readonly onRemove?: () => void
	readonly removeDisabled?: boolean
	readonly errors?: readonly string[]
}

export function TrainingProgramCard({
	program,
	onEdit,
	onRemove,
	removeDisabled,
	errors,
}: Props) {
	const title = trainingProgramCardTitle(program)
	const summary = formatTrainingProgramSummary(program)
	const hasErrors = Boolean(errors && errors.length > 0)
	const description = hasErrors ? `${summary} • Needs attention` : summary

	return (
		<EntityCard
			title={title}
			description={description}
			onEdit={onEdit}
			onRemove={onRemove}
			removeDisabled={removeDisabled}
			removeLabel="Remove"
			removeConfirmTitle={TRAINING_PROGRAM_COPY.actions.removeConfirmTitle}
			removeConfirmDescription={
				TRAINING_PROGRAM_COPY.actions.removeConfirmDescription
			}
			icon={
				<GraduationCap
					className="text-muted-foreground h-3.5 w-3.5"
					aria-hidden="true"
				/>
			}
			className={
				hasErrors
					? 'border-destructive/40 ring-destructive/40 ring-1'
					: undefined
			}
			removeAriaLabel="Remove training program"
		/>
	)
}
